import { RANGE_PRESETS, type RangePreset, type useReportRange } from "@luckymenu/staff-core";
import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

/** The range in the address (`?preset=last7`, or `?preset=custom&from=…&to=…`), so Back and a reload keep it. */
export type ReportSearch = { preset?: RangePreset; from?: string; to?: string };

const DATE = /^\d{4}-\d{2}-\d{2}$/;

export function validateReportSearch(search: Record<string, unknown>): ReportSearch {
	const preset = RANGE_PRESETS.find((p) => p === search.preset);
	const date = (v: unknown) => (typeof v === "string" && DATE.test(v) ? v : undefined);
	if (!preset || preset === "today") return {};
	if (preset !== "custom") return { preset };
	const from = date(search.from);
	const to = date(search.to);
	return from && to ? { preset, from, to } : {};
}

/** The search for a range state: nothing for Today, the dates only for a custom range. */
export function searchOf(state: ReturnType<typeof useReportRange>): ReportSearch {
	if (state.preset === "today") return {};
	if (state.preset !== "custom") return { preset: state.preset };
	return { preset: "custom", from: state.range.from, to: state.range.to };
}

/** Keeps the address in step with the picker, replacing the entry. */
export function useRangeInAddress(state: ReturnType<typeof useReportRange>): void {
	const navigate = useNavigate();
	const search = searchOf(state);
	const key = JSON.stringify(search);
	useEffect(() => {
		void navigate({ to: ".", search: JSON.parse(key) as ReportSearch, replace: true });
	}, [key, navigate]);
}
